// @ts-ignore
import useBreakpoints from 'vue-next-breakpoints';

const breakpoints = useBreakpoints({
  xs: 639,
  s: [640, 1023],
  sDown: 1023,
  m: [1024, 1279],
  l: [1280, 1535],
  xl: [1536, 1919],
  xxl: [1920]
});

export default breakpoints;
